import { Fragment } from 'react';

// material-ui
import { List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Skeleton } from '@mui/material';

// project imports
import { UserAvatar3 } from './UserAvatar';

let status = {};

function MemberList({ participants = {}, isLoading, participantsStatus = [] }) {
	participantsStatus.forEach((user) => {
		status[user?.userId] = user?.status;
	});

	// console.log(participants);

	if (isLoading)
		return (
			<List>
				{[1, 2, 3, 4, 5, 6].map((index) => (
					<ListItem key={index} divider>
						<ListItemAvatar>
							<Skeleton variant="circular" width={40} height={40} />
						</ListItemAvatar>
						<ListItemText
							primary={<Skeleton animation="wave" height={24} />}
							secondary={<Skeleton animation="wave" height={16} width="60%" />}
						/>
					</ListItem>
				))}
			</List>
		);

	return (
		<List component="nav">
			{Object.entries(participants).map(([key, participant]) => (
				<Fragment key={participant.id}>
					<ListItemButton sx={{ px: 0.5 }}>
						<ListItemAvatar sx={{ display: 'flex', justifyContent: 'center' }}>
							{/* <UserAvatar user={{ online_status: status?.[key], avatar: participant.b64PicProfile, name: participant.entityFullName, base64: true }} /> */}
							<UserAvatar3 userId={key} onlineStatus={status?.[key]} />
						</ListItemAvatar>
						<ListItemText
							primary={
								// <Typography
								//   variant="h6"
								//   color="text.primary"
								//   sx={{
								//     overflow: 'hidden',
								//     textOverflow: 'ellipsis',
								//     whiteSpace: 'nowrap'
								//   }}
								// >
								// </Typography>
								participant?.entityFullName
							}
							secondary={
								// <Typography
								//   variant="caption"
								//   color="text.primary"
								//   sx={{
								//     overflow: 'hidden',
								//     textOverflow: 'ellipsis',
								//     whiteSpace: 'nowrap'
								//   }}
								// >
								//   {
								//     </Typography>}
								participant?.designation
							}
						/>
					</ListItemButton>
				</Fragment>
			))}
		</List>
	);
}

export default MemberList;
